import React from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Box, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

const Indicator = styled(Box)(({ color }) => ({
  width: "7px",
  height: "7px",
  backgroundColor: color,
  borderRadius: "50%",
  display: "inline-block",
  marginRight: "8px",
}));

const GarmentViewNavigator = ({ canvasImage, handleToolbarChange, variants }) => {
  if (!variants.length) {
    return null;
  }

  const variantLength = variants.length;
  const view = variants.findIndex((el) => el.view === canvasImage.view);
  const isFirstView = view === 0;
  const isLastView = view === variantLength - 1;

  const chevronDistance = React.useMemo(
    () => ((screen.width - canvasImage.width * canvasImage.zoom) / 2) | 0,
    [view, screen.width]
  );

  const handleNextView = React.useCallback(() => {
    handleToolbarChange(variants[view + 1].view);
  }, [view]);

  const handlePrevView = React.useCallback(() => {
    handleToolbarChange(variants[view - 1].view);
  }, [view]);

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          left: `-${chevronDistance}px`,
          right: `-${chevronDistance}px`,
          top: "calc(50% - 25px)",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <IconButton
          sx={{ visibility: isFirstView ? "hidden" : "" }}
          value={view}
          onClick={handlePrevView}
        >
          <ChevronLeftIcon fontSize="large" />
        </IconButton>

        <IconButton sx={{ visibility: isLastView ? "hidden" : "" }} onClick={handleNextView}>
          <ChevronRightIcon fontSize="large" />
        </IconButton>
      </Box>
      {variantLength > 1 && (
        <Box
          sx={{
            position: "absolute",
            left: "0",
            right: "0",
            bottom: "-10px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {variants.map((_, i) => (
            <Indicator color={view === i ? "black" : "grey"} key={String(i)} />
          ))}
        </Box>
      )}
    </>
  );
};

export default GarmentViewNavigator;
